export default {
    data() {
        return {
            table: 'user',
            groups: [],
            datas: {
                append: ['group', 'sex_text', 'sex_o_text', 'sex_p_text']
            },
            ys: {},
            show_ys: false,

        };
    },
    created() {
        this._groups();
        this._load();
    },

    methods: {

        _ys(id) {
            this.$http.post('user/ys', {
                id
            }).then(res => {

                this.ys = res.data;
            })
        },
        _groups() {
            this.$http.post('user_group/list').then((res) => {
                this.groups = res.data.data;
            });
        }
    }
};